'use strict';

/**
 * @ngdoc component
 * @name mx.SolutionBuilderAgent:MxImageView
 * @module mx.SolutionBuilderAgent
 * @restrict 'E'
 * @description
 * The mx-image-view control displays image or icon, depending on value type.
 * Params:
 * @param {string} value - image source or icon name.
 * @param {string} default-value - default source in case if no image found on server.
 * @param {string} width - image width. If value is an icon - then try to get icon size from it.
 * @param {string} height - image height. If value is an icon - then try to get icon size from it.
 * @param {string} max-width - image max width. If value is an icon - to be ignored.
 * @param {string} max-height - image max height. If value is an icon - to be ignored.
 */
angular.module('mx.SolutionBuilderAgent').component('mxImageView', {
	bindings: {
		value: '@',
		allowPreview: '@',
		defaultValue: '@',
		height: '@',
		width: '@',
		maxHeight: '@',
		maxWidth: '@',
		style: '@',
		serverBasePath: '@',
	},
	require: {
		mxContainerCtrl: '?^^mxContainer',
	},
	controller: MxImageView,
	controllerAs: 'vm',
	templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-image-view/mx-image-view.html',
});

MxImageView.$inject = ['$scope', '$mdDialog', 'mx.shell.HostUrlHelper'];

function MxImageView($scope, $mdDialog, hostHelper) {
	const vm = this;
	let value;

	vm.onImageClick = onImageClick;

	Object.defineProperty(vm, 'value', {
		get: () => value,
		set: updateValue,
	});

	vm.$onInit = function () {
		if (vm.mxContainerCtrl) {
			vm.mxContainerCtrl.registerChild($scope);
		}

		updateValue();
		vm.style = vm.style || {};
	};

	return vm;

	function onImageClick() {
		if (vm.allowPreview === 'true') {
			handleImageClick(vm.image);
		}
	}

	function handleImageClick(url) {
		$mdDialog.show({
			clickOutsideToClose: true,
			controllerAs: 'vm',
			controller: [
				'$mdDialog',
				function ($mdDialog) {
					const vm = this;
					vm.url = url;

					vm.cancel = function () {
						$mdDialog.cancel();
					};
				},
			],
			template:
				'<div class="mx-image-view--preview-dialog layout-column layout-align-center-center">' +
				'<div class="layout-row layout-align-center-center flex"><img ondragstart="return false;" src="{{vm.url}}"/></div>' +
				'<md-button class="md-accent md-raised md-hue-2" ng-click="vm.cancel()">Close</md-button>' +
				'</div>',
		});
	}

	function updateValue(newValue) {
		if (newValue) {
			if (newValue.indexOf('/') > -1 || newValue.split('.').length > 1) {
				vm.image = hostHelper.getFullImageUrl(newValue, vm.baseFolder, vm.serverBasePath);
				vm.imageStyles = {
					'object-fit': 'contain',
				};

				if (vm.height) {
					vm.imageStyles.height = vm.height;
				}
				if (vm.maxHeight) {
					vm.imageStyles.maxHeight = vm.maxHeight;
				}
				if (vm.width) {
					vm.imageStyles.width = vm.width;
				}
				if (vm.maxWidth) {
					vm.imageStyles.maxWidth = vm.maxWidth;
				}

				vm.icon = null;
			} else {
				vm.icon = newValue;
				vm.iconSize = (vm.width || vm.height || '').replace('px', '');

				vm.image = null;
			}
		} else {
			vm.image = null;
			vm.icon = null;
		}
	}
}
